import { ActionEmptyState, Button } from "@/components/ui";

export function NoOfficesCard({
  canCreateOffice,
  onCreateOffice,
}: {
  canCreateOffice: boolean;
  onCreateOffice: () => void;
}) {
  return (
    <ActionEmptyState
      title="No offices yet"
      description="Create your first office so your firm profile has a location on file."
      actions={
        canCreateOffice ? (
          <Button size="sm" onClick={onCreateOffice}>
            Create office
          </Button>
        ) : null
      }
    />
  );
}
